import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { iconEnum } from '@app/configs/model/IconEnum';
import { workOrderTotal } from '@app/pages/cmms/components/work-order/state/work-order.selectors';
import { NewIncidentComponent } from '@app/pages/cmms/components/incident/new-incident/new-incident.component';
import { NewRequestComponent } from '@app/pages/cmms/components/request/new-request/new-request.component';
import { NewWorkOrderComponent } from '@app/pages/cmms/components/work-order/new-work-order/new-work-order.component';
import { totalRequests } from '@app/pages/cmms/components/request/state/requests.selectors';
import { incidentsTotal } from '@app/pages/cmms/components/incident/state/incidents.selectors';
import { EntityAttachmentTableComponent } from '@app/pages/cmms/components/entity-attachment-table/entity-attachment-table.component';
import { EditWorkOrderComponent } from '@app/pages/cmms/components/work-order/edit-work-order/edit-work-order.component';
import { EditIncidentComponent } from '@app/pages/cmms/components/incident/edit-incident/edit-incident.component';
import { EditRequestComponent } from '@app/pages/cmms/components/request/edit-request/edit-request.component';
import { EditFileEntityComponent } from '@app/pages/cmms/components/files/edit-file-entity/edit-file-entity.component';
import { totalFiles } from '@app/pages/cmms/components/files/state/files.selectors';
import { ComponentType } from '@angular/cdk/portal';
import { ISidebarConfig } from '@app/layout/au-right-sidebar/right-sidebar.interfaces';
import { EditAssetComponent } from '@app/pages/cmms/components/assets/edit-asset/edit-asset.component';
import { assetsTotal } from '@app/pages/cmms/components/assets/state/assets.selectors';
import { NewAssetComponent } from '@app/pages/cmms/components/assets/new-asset/new-asset.component';
import { FileIncidentListComponent } from '../components/files/file-incident-list/file-incident-list.component';
import { NewMessageComponent } from '@app/pages/messages/components/new-message/new-message.component';

export const ACTIVE_PAGE_CONFIG: {
	[key: string]: {
		createComponent: ComponentType<any>;
		sidebarConfig: Partial<ISidebarConfig>;
		dataCountSelector?: (state) => any;
	};
} = {
	// TODO Make this great again after rollback in reducer
	[CmmsPages.wo]: {
		createComponent: NewWorkOrderComponent,
		sidebarConfig: {
			title: { prefix: 'new_text', text: 'work_order' },
			icon: iconEnum.cmms,
			actionBtnName: 'submit',
			showContentActions: true,
			propagateCloseEvent: true,
			attachmentMenu: false,
		},
		dataCountSelector: workOrderTotal,
	},
	[CmmsPages.newWorkOrder]: {
		createComponent: NewWorkOrderComponent,
		sidebarConfig: {
			title: { prefix: 'new_text', text: 'work_order' },
			icon: iconEnum.cmms,
			actionBtnName: 'submit',
			showContentActions: true,
			propagateCloseEvent: true,
			attachmentMenu: false,
		},
	},
	[CmmsPages.editWorkOrder]: {
		createComponent: EditWorkOrderComponent,
		sidebarConfig: {
			title: { text: 'work_order' },
			icon: iconEnum.cmms,
			showContentActions: false,
			attachmentMenu: false,
		},
	},
	[CmmsPages.incidents]: {
		createComponent: NewIncidentComponent,
		sidebarConfig: {
			title: { prefix: 'new_text', text: 'incident' },
			icon: iconEnum.incident,
			actionBtnName: 'submit',
			showContentActions: true,
			propagateCloseEvent: true,
			attachmentMenu: false,
		},
		dataCountSelector: incidentsTotal,
	},
	[CmmsPages.newIncident]: {
		createComponent: NewIncidentComponent,
		sidebarConfig: {
			title: { prefix: 'new_text', text: 'incident' },
			icon: iconEnum.incident,
			actionBtnName: 'submit',
			showContentActions: true,
			propagateCloseEvent: true,
			attachmentMenu: false,
		},
	},
	[CmmsPages.editIncident]: {
		createComponent: EditIncidentComponent,
		sidebarConfig: {
			title: { text: 'incident_id' },
			icon: iconEnum.incident,
			showContentActions: false,
			attachmentMenu: false,
		},
	},
	[CmmsPages.requests]: {
		createComponent: NewRequestComponent,
		sidebarConfig: {
			title: { prefix: 'new_text', text: 'request' },
			icon: iconEnum.request,
			actionBtnName: 'submit',
			showContentActions: true,
			propagateCloseEvent: true,
			attachmentMenu: false,
		},
		dataCountSelector: totalRequests,
	},
	[CmmsPages.newRequest]: {
		createComponent: NewRequestComponent,
		sidebarConfig: {
			title: { prefix: 'new_text', text: 'request' },
			icon: iconEnum.request,
			actionBtnName: 'submit',
			showContentActions: true,
			propagateCloseEvent: true,
			attachmentMenu: false,
		},
	},
	[CmmsPages.editRequest]: {
		createComponent: EditRequestComponent,
		sidebarConfig: {
			title: { text: 'request_id' },
			icon: iconEnum.request,
			showContentActions: false,
			attachmentMenu: false,
		},
	},
	[CmmsPages.existingEntities]: {
		createComponent: EntityAttachmentTableComponent,
		sidebarConfig: {
			title: { prefix: 'attach', text: 'entity' },
			icon: iconEnum.incident,
			actionBtnName: 'attach',
			showContentActions: true,
			allowFullscreen: true,
			propagateCloseEvent: true,
			attachmentMenu: true,
		},
	},
	[CmmsPages.files]: {
		createComponent: null,
		sidebarConfig: null,
		dataCountSelector: totalFiles,
	},
	[CmmsPages.editFile]: {
		createComponent: EditFileEntityComponent,
		sidebarConfig: {
			title: { prefix: 'edit', text: 'file' },
			icon: iconEnum.file,
			showContentActions: false,
			allowFullscreen: true,
			attachmentMenu: false,
		},
	},
	[CmmsPages.editAsset]: {
		createComponent: EditAssetComponent,
		sidebarConfig: {
			title: { text: 'asset' },
			icon: iconEnum.asset,
			showContentActions: false,
			propagateCloseEvent: false,
			attachmentMenu: false,
		},
	},
	[CmmsPages.newAsset]: {
		createComponent: NewAssetComponent,
		sidebarConfig: {
			title: { prefix: 'new_text', text: 'asset' },
			icon: iconEnum.asset,
			showContentActions: true,
			actionBtnName: 'submit',
			propagateCloseEvent: true,
			attachmentMenu: false,
		},
	},
	[CmmsPages.assets]: {
		createComponent: NewAssetComponent,
		sidebarConfig: {
			title: { prefix: 'new_text', text: 'asset' },
			icon: iconEnum.asset,
			showContentActions: true,
			actionBtnName: 'submit',
			propagateCloseEvent: true,
			attachmentMenu: false,
		},
		dataCountSelector: assetsTotal,
	},
	[CmmsPages.fileDetector]: {
		createComponent: FileIncidentListComponent,
		sidebarConfig: {
			title: { prefix: 'detected', text: 'incidents' },
			icon: iconEnum.report_sign,
			allowFullscreen: true,
			showContentActions: false,
		},
	},
	[CmmsPages.messages]: {
		createComponent: NewMessageComponent,
		sidebarConfig: {
			title: { prefix: 'send_new', text: 'message' },
			actionBtnName: 'send_message',
			icon: iconEnum.email,
			allowFullscreen: false,
			showContentActions: true,
			propagateCloseEvent: true,
		},
	},
	[CmmsPages.viewMessage]: {
		createComponent: NewMessageComponent,
		sidebarConfig: {
			title: { text: 'message' },
			icon: iconEnum.email,
			allowFullscreen: false,
			showContentActions: false,
			propagateCloseEvent: true,
		},
	},
};
